import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import App from "./App";
import { LiffProvider } from "react-liff";
import config from "./utils/config";
import { HelmetProvider } from "react-helmet-async";
import { createRoot, hydrateRoot } from "react-dom/client";

const CONFIG = config.config();
const liffId = CONFIG.LIFF_ID;
let initialized = false;

const isExceptionPath = () => {
  const path = window.location.pathname;

  // ใช้ regex ตรวจจับ path ที่ควรยกเว้น (เฉพาะ receipt + register เท่านั้น)
  const receiptMatch = /^\/my-loan-receipt\/\d+\/\d+\/detail$/;
  const registerMatch = path.startsWith("/register");

  return receiptMatch.test(path) || registerMatch;
};
const fnHandleLiff = (liff) => {
  // ถ้าไม่ได้อยู่ใน LINE client → ใช้ app เป็น web browser ปกติ (ไม่ redirect ไป LINE)
  if (!liff.isInClient()) {
    console.log("Not in LINE client — running as regular web app");
    return;
  }

  // === ด้านล่างนี้ทำงานเฉพาะใน LINE LIFF เท่านั้น ===
  if (initialized === false) {
    initialized = true;

    if (typeof liff.error !== "undefined") {
      // console.warn("error", liff.error);
    }

    liff.ready.then(() => {
      console.log("ready :", liff.isLoggedIn());

      if (!liff.isLoggedIn()) {
        liff.login({ redirectUri: window.location.href });
        return;
      }

      liff
        .getProfile()
        .then((profile) => {
          console.log("profile :", profile);
        })
        .catch((err) => {
          console.log("error :", err);
        });
    });
  }
};

export const queryClient = new QueryClient();

// const path = window.location.pathname;
// const isDesktop = /Win32|Win64|MacIntel|Linux x86_64|X11/.test(
//   navigator.platform
// );
// const isMobileDevice = () => {
//   return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
//     navigator.userAgent
//   );
// };
// if (path.includes("error")) {
//   root.render(<div>ERROR USE ON MOBILE ONLY</div>);
// }

const rootElement = document.getElementById("root");

// Skip LiffProvider when running on localhost (local browser dev)
// In LINE client or deployed environments, always use LiffProvider
const isLocalDev = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
const isRunningInLine = window.navigator.userAgent.includes("Line") || window.location.search.includes("liff.state");
const shouldSkipLiff = isLocalDev && !isRunningInLine;

const AppWrapper = () => {
  if (shouldSkipLiff) {
    return (
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </HelmetProvider>
    );
  }

  return (
    <HelmetProvider>
      <LiffProvider liffId={liffId} callback={fnHandleLiff}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </LiffProvider>
    </HelmetProvider>
  );
};

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, <AppWrapper />);
} else {
  createRoot(rootElement).render(<AppWrapper />);
}
